import HttpClient from '../HttpClient'

export default class OfferService {

    static previous = async (request_id: number, params: any) : Promise<any> => {
        return HttpClient.get(`v2/requests/${request_id}/offers/previous`, params)
    }

}
